import axios from "axios"
import webconfig from '../webconfig.json'
import { validaToken, getToken } from "../auth"

const apiComunicacaoOficial = axios.create({
  baseURL: webconfig.ApiComunicaoOficial,
})

apiComunicacaoOficial.interceptors.request.use(async config => {
    const token = getToken()        
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
      validaToken()
    }

    return config
})

export default apiComunicacaoOficial